import { EzrImage } from "ui-widgets";
import React from "react";
import background_image from "datalign-module-template/assets/blue-two-min-grey.png";
import { Box, Typography } from "@mui/material";
import { useEasierTheme } from "datalign-themes";
import Header from "components/sitelet/header/Header";

const MissingPage = () => {
  const theme = useEasierTheme();

  return (
    <Box
      sx={() => ({
        padding: "32px",
        flex: 1,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        overflowX: "hidden",
        position: "relative",
        width: "100%",
        height: "100%",
        background: theme?.Colour.SurfaceContainerLowest(),
      })}
    >
      <EzrImage
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          objectFit: "cover",
          overflow: "hidden",
          zIndex: 0,
        }}
        src={background_image}
      />
      <Header showBreadcrumb={false} />

      <Typography
        variant={"h2"}
        fontSize={"45px"}
        lineHeight={"52px"}
        fontWeight={400}
      >
        Page not found!
      </Typography>
    </Box>
  );
};

export default MissingPage;
